export const WAITING_LIST_WS_PATH = 'waiting-list'
